import React from "react";
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css'; 
import LiveCount from './LiveCount';   
import CustomDashboard from './CustomDashboard';   
import StateDashboard from './StateDashboard';   
const IndexPage = () => {
  return (
    <a
    href="https://doortally.com"
      target="_blank"
      rel="noopener noreferrer"
      >
    <img src="poweredby.png" className="dt-logo" alt="logo" style={{"width": '50%'}} />
    </a>
  );
}; 
 
function App() { 
  
  return (
    <div className="App">
       <Router> 
        <Route exact path="/" component={IndexPage} />
        <Route exact path="/custom/:account_id" component={CustomDashboard} />
        <Route exact path="/public/:account_id" component={StateDashboard} />
        <Route exact path="/:location_id" component={LiveCount} />
      </Router>
    </div>
  );
}

export default App;
